'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (_ref) {
    var data = _ref.data,
        _ref$seriesId = _ref.seriesId,
        seriesId = _ref$seriesId === undefined ? data.headers[0].name : _ref$seriesId,
        _ref$categoryId = _ref.categoryId,
        categoryId = _ref$categoryId === undefined ? data.headers[1].name : _ref$categoryId;

    var headers = data.headers;
    var metaData = data.metaData;
    var rows = data.rows;
    var headerIdIndexMap = getHeaderIdIndexMap(headers);

    var seriesIndex = headerIdIndexMap.get(seriesId);
    var categoryIndex = headerIdIndexMap.get(categoryId);
    var valueIndex = headerIdIndexMap.get(VALUE_ID);

    var seriesHeader = headers[seriesIndex];
    var categoryHeader = headers[categoryIndex];

    var idValueMap = getIdValueMap(rows, seriesHeader, categoryHeader, valueIndex);

    var seriesIds = metaData.dimensions[seriesId];
    var categoryIds = metaData.dimensions[categoryId];

    return getData(seriesIds, categoryIds, idValueMap, metaData.items);
};

var VALUE_ID = 'value';

function getHeaderIdIndexMap(headers) {
    var map = new Map();

    headers.forEach(function (header, index) {
        map.set(header.name, index);
    });

    return map;
}

function getPrefixedId(row, header) {
    return (header.isPrefix ? header.name + '_' : '') + row[header.index];
}

function getIdValueMap(rows, seriesHeader, categoryHeader, valueIndex) {
    var map = new Map();

    var key = void 0;
    var value = void 0;

    rows.forEach(function (row) {
        key = getPrefixedId(row, seriesHeader) + '-' + getPrefixedId(row, categoryHeader);
        value = row[valueIndex];

        map.set(key, value);
    });

    return map;
}

function getData(seriesIds, categoryIds, idValueMap, metaDataItems) {
    var data = [];
    var dataItem = void 0;
    var value = void 0;

    seriesIds.forEach(function (seriesId) {
        dataItem = {
            name: metaDataItems[seriesId].name,
            data: []
        };

        categoryIds.forEach(function (categoryId) {
            value = idValueMap.get(seriesId + '-' + categoryId);

            // DHIS2-1261: 0 is a valid value
            // undefined value means the key was not found within the rows
            // in that case null is returned as value in the serie for highcharts
            dataItem.data.push(value == undefined ? null : parseFloat(value));
        });

        data.push(dataItem);
    });

    return data;
}
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-charts-api/lib/store/adapters/dhis_highcharts/index.js
 ** module id = 222
 ** module chunks = 0 1
 **/